import awaitPeerDependencies from '@ssr/registry';
import { loadEnv } from './load-env';

loadEnv();

const registryDependencies = [
  'react',
  'react-dom',
  'react-intl',
  'styled-components',
];

const index = translations => {
  return awaitPeerDependencies(registryDependencies).then(
    ({ react: React, 'react-dom': ReactDom }) => {
      import(/* webpackChunkName: "app" */ '../../app')
        .then(({ default: App }) => {
          const { __environment__, ...state } = window.SSR_HEADER_STATE || {};

          ReactDom.hydrate(
            <App state={state} translations={translations} />,
            document.getElementById('fragment-header'),
            () => {
              // css styles are not required anymore once the applications has hydrated
              const tamagoshiSSRStyles = document.getElementById(
                'tamagoshi-ssr-styles-header',
              );

              if (tamagoshiSSRStyles !== null) {
                tamagoshiSSRStyles.parentNode.removeChild(tamagoshiSSRStyles);
              }
            },
          );
        })
        .catch(e => {
          console.log(e); // eslint-disable-line no-console
        });
    },
  );
};

export { index };
